import {KodataCategory} from '@/enums';

export const KODATA_CATEGORY_DETAIL = [
  'pc방',
  '놀이방',
  '학원(교육/입시)',
  '학원(기타)',
  '학원(예체능)',
  '기타도소매',
  '도소매(문구)',
  '도소매(식음류)',
  '도소매(의류)',
  '도소매(책/서적)',
  '면세점',
  '백화점',
  '유아용품',
  '아이스크림',
  '아시안',
  '도시락',
  '분식',
  '세탁/빨래방',
  '기타생활서비스',
  '노인요양서비스',
  '대여/렌탈',
  '대중교통',
  '렌트카',
  '미용실',
  '반려동물',
  '병/의원',
  '부동산(임대)',
  '뷰티/헬스케어',
  '수리/수선',
  '숙박업소',
  '운송/이사',
  '운전연수',
  '의약품판매',
  '주유/세차',
  '중개/고용/알선',
  '스터디카페·독서실',
  '양식',
  '골프',
  '문화/관람시설',
  '여가·오락(기타)',
  '오락/스포츠(실내)',
  '오락/스포츠(실외)',
  '기타일식',
  '돈까스/카레',
  '초밥/사시미',
  '유흥주점',
  '일반주점',
  '중식',
  '치킨/바베큐',
  '커피/음료',
  '패스트푸드',
  '피자',
  '고기/구이',
  '국수/만두/죽/샤브',
  '기타한식',
  '닭요리',
  '뷔페',
  '족발/보쌈',
  '탕/찌개/볶음',
  '백반/한정식',
  '회/해물/생선(한식)',
];

export const KODATA_MAP_CATEGORIES = {
  [KodataCategory.KOREAN]: [
    '고기/구이',
    '국수/만두/죽/샤브',
    '기타한식',
    '닭요리',
    '백반/한정식',
    '뷔페',
    '족발/보쌈',
    '탕/찌개/볶음',
    '회/해물/생선(한식)',
  ],
  [KodataCategory.PIZZA]: ['피자'],
  [KodataCategory.CONVENIENCE]: ['슈퍼/마트', '편의점'],
  [KodataCategory.FASTFOOD]: ['패스트푸드'],
  [KodataCategory.CAFE]: ['커피/음료'],
  [KodataCategory.CHICKEN]: ['치킨/바베큐'],
  [KodataCategory.CHINESE]: ['중식'],
  [KodataCategory.PUB]: ['유흥주점', '일반주점'],

  [KodataCategory.BAKERY]: ['떡/찐빵', '베이커리/샌드위치/샐러드'],
  [KodataCategory.JAPANESE]: ['기타일식', '돈까스/카레', '초밥/사시미'],

  [KodataCategory.LEISURE]: [
    '골프',
    '문화/관람시설',
    '여가·오락(기타)',
    '오락/스포츠(실내)',
    '오락/스포츠(실외)',
  ],
  [KodataCategory.WESTERN]: ['양식'],
  [KodataCategory.STUDY]: ['스터디카페·독서실'],
  [KodataCategory.LIFE]: [
    '기타생활서비스',
    '노인요양서비스',
    '대여/렌탈',
    '대중교통',
    '렌트카',
    '미용실',
    '반려동물',
    '병/의원',
    '부동산(임대)',
    '뷰티/헬스케어',
    '수리/수선',
    '숙박업소',
    '운송/이사',
    '운전연수',
    '의약품판매',
    '주유/세차',
    '중개/고용/알선',
  ],

  [KodataCategory.LAUNDRY]: ['세탁/빨래방'],
  [KodataCategory.SNACK]: ['분식', '도시락'],
  [KodataCategory.FUSION]: ['아시안'],
  [KodataCategory.DESSERT]: ['아이스크림'],
  [KodataCategory.WHOLESALE_RETAIL]: [
    '기타도소매',
    '도소매(문구)',
    '도소매(식음류)',
    '도소매(의류)',
    '도소매(책/서적)',
    '면세점',
    '백화점',
    '유아용품',
  ],

  [KodataCategory.EDUCATION]: [
    '놀이방',
    '학원(교육/입시)',
    '학원(기타)',
    '학원(예체능)',
  ],

  [KodataCategory.INTERNET_CAFE]: ['pc방'],
};

export const KODATA_AVG_SALES_RANGE = [
  [0, 10_000_000],
  [10_000_000, 30_000_000],
  [30_000_000, 50_000_000],
  [50_000_000, 100_000_000],
  [100_000_000, 200_000_000],
  [200_000_000],
];
